module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Schneckenhof-Weingut","short_name":"Weingut","start_url":"/","background_color":"#222","theme_color":"#be906c","display":"minimal-ui","icon":"src/assets/images/logo_visual.svg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"6f29872ed12643069e692a2aafa36f82"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-3744376-1","head":false,"anonymize":true,"respectDNT":true,"exclude":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
